var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "movement-control-container"
  }, [_c('div', {
    staticClass: "movement-control up",
    class: {
      'inactive': _vm.inactiveUp
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('movementUp');
      }
    }
  }, [_c('span', {
    staticClass: "movement-control-icon"
  })]), _c('div', {
    staticClass: "movement-control down",
    class: {
      'inactive': _vm.inactiveDown
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('movementDown');
      }
    }
  }, [_c('span', {
    staticClass: "movement-control-icon"
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }